<template>
  <div class="vx-row">
      <vx-card title="PRICING TIERS">

        <template slot="actions">
          <div class="flex float-right">
            <div class="con-btns-user flex items-center justify-between">
              <div class="flex mb-4">
                <vs-button v-can="'create-pricing-tier'" @click="onClickCreateTenant" class="mr-4" color="primary" type="filled">Create pricing tier</vs-button>

                <vx-tooltip class="mr-2" text="Refresh" position="left">
                  <vs-button @click="onClickRefresh" class="mr-0" color="success" type="border"
                           icon-pack="feather" icon="icon-rotate-cw"></vs-button>
                </vx-tooltip>
              </div>
            </div>
          </div>
        </template>

        <div slot="no-body" class="mt-4">

          <vs-table :max-items="10" :data="pricing_tiers" :sst="true" stripe id="pricing-tier-table"
                    class="table-dark-inverted table-auto vs-con-loading__container">>

            <template slot="thead">
              <vs-th width="20%">NAME</vs-th>
              <!-- <vs-th width="20%">SETUP CHARGE (GBP)</vs-th> -->
              <!-- <vs-th width="20%">PRICE (GBP)</vs-th> -->
              <!-- <vs-th width="20%">STATUS</vs-th> -->
              <vs-th width="20%">ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr  :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>

                <!-- <vs-td :data="data[indextr].setup_charge">
                  {{ data[indextr].setup_charge }}
                </vs-td>

                <vs-td :data="data[indextr].price">
                  {{ data[indextr].price }}
                </vs-td> -->

                <!-- <vs-td :data="data[indextr].is_active">
                  <vs-chip transparent :color="data[indextr].is_active ? 'primary' : 'danger'">
                    {{ data[indextr].is_active ? 'Active' : 'Inactive' }}
                  </vs-chip>
                </vs-td> -->

                <vs-td>
                  <div class="vx-row">
                    <vx-tooltip v-can="'view-pricing-tier'" class="mr-2" text="View/Update" position="left">
                      <vs-button @click.stop="onClickViewPricingTier(data[indextr].id)"
                                 size="small" color="primary" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>

              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vx-card>

    <create-tenant-pop-up ref="createTenantPopUp"/>
    <update-tenant-pop-up ref="updateTenantPopUp"/>

  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import CreateTenantPopUp from "@/components/popups/tenants/CreateTenantPopUp";
import UpdateTenantPopUp from "@/components/popups/tenants/UpdateTenantPopUp";
const PricingRepository = RepositoryFactory.get('pricing')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

export default {
  name: 'PricingTierList',
  data () {
    return {
      pricing_tiers: [],
    }
  },
  components: {
    CreateTenantPopUp,
    UpdateTenantPopUp,
  },
  async mounted () {
    await this.fetchPricingTiers()
  },
  methods: {
    async refreshData () {
      await this.fetchPricingTiers()
    },
    async onClickViewPricingTier (id) {
      await this.$router.push(`/pages/pricing-tiers/${id}`)
    },
    async fetchPricingTiers() {
      await this.$vs.loading({
        container: '#pricing-tier-table',
        scale: 0.50
      });
      try {
        const {data} = await PricingRepository.get()
        this.pricing_tiers =  data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#pricing-tier-table > .con-vs-loading')
    },
    async onClickCreateTenant () {
      await this.$router.push('/pages/pricing-tiers/create')
    },
    async onClickRefresh() {
      await this.fetchPricingTiers()
    },
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>


<style scoped>

</style>
